module.exports = __webpack_public_path__ + "static/green-sunburst-background-8590d4133167cd0879f161437fa3a5c8.svg";